import { createAsyncThunk } from '@reduxjs/toolkit';

import { defaultActionProcess } from 'commons/utils/defaultActionProcess';
import { setInboundInvoice } from 'redux-stores/reducers/inboundInvoiceReducer';
import { setSearchedQueueDocument } from 'redux-stores/reducers/inboundTaskDocumentReducer';
import { swipeRxWmsApiInboundTaskDocument } from 'services/apis/SwipeRxWmsApiInboundTaskDocument';

export const getUserInProgressInboundTaskDocumentAndInvoice = createAsyncThunk(
  'inboundTaskItem/getUserInProgressInboundTaskDocumentAndInvoice',
  async (_, { dispatch }) => {
    defaultActionProcess(async () => {
      const data =
        await swipeRxWmsApiInboundTaskDocument.getUserInProgressInboundTaskDocumentAndInvoice();
      dispatch(setSearchedQueueDocument(data.inbound_task_document));
      dispatch(setInboundInvoice(data.inbound_invoice));
    }, dispatch);
    return undefined;
  },
);

export const getInProgressInboundTaskDocument = createAsyncThunk(
  'inboundTaskItem/getInboundTaskDocument',
  async (params: { inboundTaskNumber: string }, { dispatch }) => {
    defaultActionProcess(async () => {
      const data =
        await swipeRxWmsApiInboundTaskDocument.getInProgressInboundTaskDocument(
          params.inboundTaskNumber,
        );
      dispatch(setSearchedQueueDocument(data));
    }, dispatch);
    return undefined;
  },
);
